import firebase from 'firebase'

const config = {
  apiKey: "AIzaSyD9kASL9MAJLDhZqb1egG0FfllYeBRMdJU",
  authDomain: "stocksheet001.firebaseapp.com",
  databaseURL: "https://stocksheet001.firebaseio.com",
  projectId: "stocksheet001",
  storageBucket: "stocksheet001.appspot.com",
  messagingSenderId: "331928097099"
};
if (!firebase.apps.length) {

  firebase.initializeApp(config);
}

const db = firebase.database();
const auth = firebase.auth();

export {
  db,
  auth,
};



// WEBPACK FOOTER //
// ./src/firebase/firebase.js